import { Observable, animationFrameScheduler, auditTime } from 'rxjs';

import { D3ChartSvg, D3CursorEvent } from '@shared/types/common-graph.types';
import { mapTouchEventToD3CursorEvent } from '@shared/utils/event';

export const fromSvgEvent$ = (svg: D3ChartSvg, eventName: string): Observable<D3CursorEvent> => {
  return new Observable<D3CursorEvent>((observer) => {
    svg.on(eventName, (e) => {
      if ('clientX' in e) {
        observer.next(e as D3CursorEvent);
      } else {
        observer.next(mapTouchEventToD3CursorEvent(e as TouchEvent));
      }
    });

    return () => {
      svg.on(eventName, null);
    };
  }).pipe(auditTime(0, animationFrameScheduler));
};
